import React from 'react';
import PropTypes from 'prop-types';
import MuiCssBaseline from '@material-ui/core/CssBaseline';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  '@global': {
    '*': {
      '&[data-grid-inset]': {
        backgroundColor: 'red',
      },
      // outline: 'red 1px solid',
    },
    html: {
      fontSize: `${theme.typography.htmlFontSize}px`,
      height: '100%',
    },
    body: {
      overflowX: 'hidden',
      backgroundColor: theme.palette.common.white,
      color: theme.palette.text.default,
      height: '100%',
    },
    '#__next': {
      height: '100%',
    },
    a: {
      textDecoration: 'none',
      color: 'inherit',
    },
    b: {
      fontWeight: 600,
    },
  },
}));

const CssBaseline = ({ children }) => {
  useStyles();
  return (
    <React.Fragment>
      <MuiCssBaseline />
      {children}
    </React.Fragment>
  );
};

CssBaseline.propTypes = {
  children: PropTypes.node,
};

CssBaseline.defaultProps = {
  children: null,
};

export default CssBaseline;
